import { TCurrency } from "..";
import MethodBuilder from "../method-builder";

class CurrencyAPI {
  static getAll = new MethodBuilder<void, { data: TCurrency[] }>()
    .withName("Currency.getAll")
    .build();

  static import = new MethodBuilder<{ format: "csv"; data: string }, void>()
    .withName("Currency.import")
    .build();

  static export = new MethodBuilder<{ format: "csv" }, { data: string }>()
    .withName("Currency.export")
    .build();
}

export default CurrencyAPI;
